import ButtonIcon from "./ButtonIcon.component";

export default ButtonIcon;
